import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

import moment from 'moment'
import 'moment/locale/pt-br'

import { withStyles } from '@material-ui/core/styles'
import '../styles/exam-summary.css'
import { Button, DialogContent, Grid, GridList, GridListTile, Dialog, Snackbar } from '@material-ui/core'

import FullscreenImage from './FullscreenImage'

import examIcon from '../images/Icons/laudo.png'
import dicomIcon from '../images/Icons/raio-x.png'

const styles = theme => {}

class Summary extends Component {
    constructor(props){
        super(props);
        
        this.state = {
            exam: {},
            isImageSelected: false,
            currentImage: '',
            dicomList: [],
            thumbList: [],
            isThereDicom: false,
            isLoading: {}
        }
    }

    downloadPdf = (event) => {
        this.props.downloadPdf(event);
    };

    showDicomList = () => {

        const dicom = this.props.exam.dicom_instances.map((item) => {
            return 'wadouri:' + process.env.REACT_APP_DICOM_PROXY + '/instances/' + item + '/file'
        })

        const thumb = this.props.exam.images.map((item) => {
            return item
        })

        this.setState({
            dicomList: dicom,
            thumbList: thumb
        }, () => {
            sessionStorage.setItem('examlist', JSON.stringify(this.state.dicomList));
            sessionStorage.setItem('thumblist', JSON.stringify(this.state.thumbList));
        })        
    }

    showFullscreenImage = (event) => {
        this.setState({ 
                isImageSelected: !this.state.isImageSelected,
                currentImage: event.currentTarget.id
            }
        )
    }

    handleImageClose = () => {
        this.setState({ isImageSelected: false })
    }

    componentDidMount() {

        const isDicom = (this.props.exam.dicom_instances.length > 0)? true : false;

        this.setState({
            isThereDicom: isDicom
        })
    }

    handleSnackbarClose = (event) => {
        this.props.handleSnackbarClose(event);
    };
    
    render() {
        let ageMessage;
        let vetRequester = this.props.exam.vet_requester? this.props.exam.vet_requester.name : 'NÃO INFORMADO';

        if(this.props.exam.age_year > 1){
            if(this.props.exam.age_month > 1){
                ageMessage = <div>{this.props.exam.age_year} anos e {this.props.exam.age_month} meses</div>
            }
            else if(this.props.exam.age_month === 1){
                ageMessage = <div>{this.props.exam.age_year} anos e {this.props.exam.age_month} mês</div>
            }
            else{
                ageMessage = <div>{this.props.exam.age_year} anos</div>
            }
        }
        else if(this.props.exam.age_year === 1){
            if(this.props.exam.age_month > 1){
                ageMessage = <div>1 ano e {this.props.exam.age_month} meses</div>
            }
            else if(this.props.exam.age_month === 1){
                ageMessage = <div>1 ano e 1 mês</div>
            }
            else{
                ageMessage = <div>{this.props.exam.age_year} ano</div>
            }
        }
        else{
            if(this.props.exam.age_month > 0){
                ageMessage = <div>{this.props.exam.age_month} meses</div>
            }
            else{
                ageMessage = <div>Menos de 1 Mês</div>
            }
        }
        return (
            <div>
                <Snackbar 
                    open={this.props.error? true : false}
                    message={this.props.error}
                    TransitionComponent='Grow'
                    variant='error'
                    onClose={this.handleSnackbarClose}/>
                {this.state.isImageSelected ?
                    <Dialog
                        maxWidth='lg'
                        open={this.state.isImageSelected}
                        onClose={this.handleImageClose}>
                        <FullscreenImage image={this.state.currentImage}/>
                    </Dialog>
                :
                    null            
                }        
                <DialogContent>
                    <Grid container direction='column'>
                        <Grid item container direction='row' justify='space-around'>
                            <Grid item container sm={3} md={2} justify='center'>
                                <img className='animal-icon' src={this.props.exam.specie.icon} alt={this.props.exam.specie.name}/>
                            </Grid>
                            <Grid item container sm={6} md={6} direction='column' justify='center'>
                                <div className='animal-name'>{this.props.exam.animal}</div>
                                <div className='animal-owner'>Acompanhado por: {this.props.exam.animal_owner? this.props.exam.animal_owner : "NÃO INFORMADO"}</div>
                            </Grid>
                            <Grid item container sm={3} md={2}>
                                <Grid item container alignItems='center' className='button-container'>
                                    <Button variant='contained' 
                                        className='report-button'
                                        onClick={this.downloadPdf}>
                                        <Grid item container direction='column' alignItems='center'>
                                            <img src={examIcon} alt='Laudo' className='icon'/>
                                            Ver Laudo
                                        </Grid>                        
                                    </Button>
                                </Grid>
                                <Grid item container alignItems='center' className='button-container'>
                                    {this.state.isThereDicom ? 
                                        <Button variant='contained'
                                                className='report-button'>
                                                <Link 
                                                    onClick={this.showDicomList}
                                                    style={{textDecoration: 'none'}}
                                                    to={{
                                                    pathname: `/visualizador`,
                                                    }}
                                                    target='_blank'>       
                                                    <Grid item container direction='column' alignItems='center'>
                                                        <img src={dicomIcon} alt='Dicom' className='icon'/>
                                                        Ver Dicoms
                                                    </Grid>
                                                </Link>                        
                                        </Button>
                                    :
                                    null}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item><hr className='horizontal-line'/></Grid>
                        <Grid item container direction='row' className='info-container'>
                            <Grid item xs={3} container justify='flex-start'>
                                <div>
                                    <div className='info-header' style={{color: 'inherit'}}>{this.props.exam.specie.name}</div>
                                    {ageMessage}
                                </div>                            
                            </Grid>
                            <Grid item container xs={6} justify='space-evenly'>
                                {this.props.exam.clinic_requester &&
                                    <Grid item xs={6} justify='center'>
                                        <div>
                                            <div className='info-header'>Clínica solicitante:</div>
                                            {this.props.exam.clinic_requester.name}
                                        </div>                            
                                    </Grid>
                                }
                                <Grid item xs={6} justify='center'>
                                    <div>
                                        <div className='info-header'>Veterinário solicitante:</div>
                                        <div>{vetRequester}</div>
                                    </div>                            
                                </Grid>                                
                            </Grid>
                            <Grid item xs={3} container justify='flex-end'>
                                <div>
                                    <div className='info-header'>Data do Exame:</div>
                                    {moment(this.props.exam.created).format("DD [de] MMMM [de] YYYY")}
                                    <br/>
                                    às {moment(this.props.exam.created).format("HH:mm")}
                                </div>
                            </Grid>
                        </Grid>
                        <Grid item><hr className='horizontal-line'/></Grid>
                        <Grid item container direction ='row' justify='center' className='thumb-zone'>
                            {(this.props.exam.images.length < 5) ?
                                this.props.exam.images.map((item, index) => (
                                    <Button
                                        key={'button ' + index}
                                        id={item}
                                        onClick={this.showFullscreenImage}>
                                        <img                                        
                                            className='xray-thumb'
                                            src={item}
                                            alt={'imagem ' + index}/>
                                    </Button>                                 
                                ))
                            :
                            <GridList cols={4} cellHeight='10px' className='thumb-scroll'>
                                {this.props.exam.images.map((item, index) => (
                                    <GridListTile>
                                        <Button
                                            id={item}
                                            onClick={this.showFullscreenImage}>
                                            <img                                        
                                                className='xray-thumb'
                                                src={item}
                                                alt={'imagem ' + index}/>
                                        </Button>
                                    </GridListTile>                                  
                                ))}
                            </GridList>
                            }
                        </Grid>
                    </Grid>
                </DialogContent>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
    }   
}

function mapDispatchToProps(dispatch) {
    return {
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Summary)));